import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import MuiListItemButton from '@mui/material/ListItemButton';
import React from 'react';
import { FlexBox } from '../../box';
import { FacilityBadge } from '../../facility-picker/badge';
import { Item } from '../../list/item';
import { styled } from '../../styled';
import { Typography } from '../../typography';
import { Autocomplete } from '../index';
const StyledInputWrapper = styled(FlexBox)(({ theme }) => ({
    paddingRight: theme.spacing(2)
}));
export const FacilityAutocomplete = ({ moreText, onHover, ...props }) => {
    const startAdornment = props.value ? (_jsx(StyledInputWrapper, { children: onHover ? (_jsx(FacilityBadge.Async, { label: props.value.sharedFacilities, onFetch: () => onHover(props.value), moreText: moreText })) : (_jsx(FacilityBadge, { facilityInfo: props.value, moreText: moreText })) })) : null;
    const renderOption = (liProps, facilityOption, state) => {
        const label = props.getOptionLabel?.(facilityOption) ?? facilityOption.name;
        return (_createElement(MuiListItemButton, { ...liProps, key: facilityOption.id, component: "li" },
            _jsx(Item, { selected: state.selected, facilityBadge: onHover
                    ? {
                        label: facilityOption.sharedFacilities,
                        onFetch: () => onHover(facilityOption),
                        moreText
                    }
                    : {
                        facilityInfo: facilityOption,
                        moreText
                    }, primary: _jsx(Typography, { children: label }) })));
    };
    return (_jsx(Autocomplete, { ...props, multiple: false, InputProps: {
            ...props.InputProps,
            startAdornment
        }, renderOption: renderOption }));
};
